import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseCellComponent } from '../base-cell.component';

/**
 * Ячейка для типа данных "Текст"
 */
@Component({
    selector: 'app-text-cell',
    template: '{{ getValue() }} ',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextCellComponent extends BaseCellComponent {
    /**
     * Для значений в этих ячейках
     * 1. Заменяем &nbsp; на обычные пробелы
     * 2. Добавляем пробел после блочных HTML тегов
     * 3. Удаляем HTML теги совсем
     */
    getValue() {
        return this.getRawValue()
            .replace(/&nbsp;/g, ' ')
            .replace(/<\s*(div|p|h[1-6]|ul|ol|li|blockquote|br)(\s+[^>]*?)?\s*>/g, ' ')
            .replace(/<[^>]*>/g, '');
    }
}
